


<template>
    <HeaderContent title="Admin"/>
    <ActionContent ctaText="Admin" @action="modal = !modal "/>
    <AdminStatistics title="Admin Statistics" :data="statistics" />
    <AdminForm :modal="modal" @update:modal="modal = $event"></AdminForm>
    <AdminDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/>

</template>

<script >

import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import AdminForm from './AdminForm.vue';
import AdminDataTable from '@/components/DataTable.vue';
import AdminStatistics from '@/components/StatisticData.vue';
import iconUser from '../../../public/icons/users-alt.svg';
import adminDummy from '@/dummy-data/admin.js'
import { ref, } from 'vue';

export default{
    name : 'AdminIndex',
    components: {
        HeaderContent,
        ActionContent,
        AdminForm,  
        AdminDataTable,
        AdminStatistics
    },
    setup(){
        const modal = ref(false)
        const statistics = ref([
            {
                label: 'Total',
                key: 'User',
                value: 8,
                color: 'primary',
                icon: iconUser,
            },
            ])
        const data = adminDummy


    const headers = ref([
        {key : 'no',label: 'No',sortable: true,},
        {key : 'username', label : 'Username', class : 'text-left',sortable: true,},
        {key : 'Level_admin', label : 'Level',class : 'text-left',sortable: true,},
        {key : 'phone_number', label : 'Phone Number', class:'tex-left',sortable: true,},
        {key : 'email', label : 'Email', class:'text-left',sortable: true,},
        {key : 'address', label : 'Address',class:'text-left',sortable: true,},
        {key: 'action', label: 'Actions',}
    ])
    const customActions = ref([
        {
            label: 'Non active data',
            variant: 'warning',
            icon: 'fas fa-user-slash',
            action: (item) => {

            console.log('Extra charge action clicked for:', item);
            // Implement your extra charge logic here
            }
        },
        {
            label: 'Edit',
            variant: 'success',
            icon: 'fas fa-edit',
            action: (item) => {
            console.log('Edit action clicked for:', item);
            // Implement your edit logic here
            }
        },
        {
            label: 'Delete',
            variant: 'danger',
            icon: 'fas fa-trash',
            action: (item) => {
            console.log('Delete action clicked for:', item);
            // Implement your delete logic here
            }
        },
        
    ]);

    return { 
            modal,
            statistics,
            headers,
            customActions,
            data
        }
    }
}

</script>
